module.exports = __webpack_public_path__ + "img/brand_logo_illustration_card.1105399a.svg";